import { FormattedMessage } from 'react-intl';

export function RecoverPasswordErrorFallback() {
  return (
    <h2>
      <FormattedMessage
        id="recover-password-page.generic-error"
        defaultMessage="Could not start the password recovery process. Please reach out to support."
      />
    </h2>
  );
}
